'use client';

import type { ReactNode } from 'react';
import { useState } from 'react';

import { idx } from '../../_lib/marketing-utils';
import { MarketingImage } from '../ui/marketing-image';

/** Home "Why Locari" USP card with expandable detail (prototype §5). */
export function UspCard({
  index,
  img,
  chip,
  title,
  body,
  detail,
  toggleLabel,
}: {
  index: number;
  img: string;
  chip: string;
  title: ReactNode;
  body: ReactNode;
  detail: ReactNode;
  toggleLabel: string;
}) {
  const [open, setOpen] = useState(false);
  const detailId = `usp-expand-${index + 1}`;

  return (
    <article
      // className MUSS statisch bleiben: der globale RevealController setzt
      // `is-visible` imperativ per DOM auf `.reveal`. Würde React hier die
      // className togglen (`reveal is-open`), überschriebe das Re-Render das
      // `is-visible` → Karte fällt auf `.reveal:not(.is-visible)` = unsichtbar
      // (Bug: Pillar verschwindet beim Aufklappen). Daher Toggle via data-open.
      className="usp-card reveal"
      style={idx(index)}
      data-expand
      data-open={open ? 'true' : undefined}
    >
      <div className="usp-figure">
        <MarketingImage src={img} alt="" loading="lazy" />
      </div>
      <span className="usp-chip">{chip}</span>
      <h3 className="h-card">{title}</h3>
      <p className="body-text">{body}</p>
      <div className="usp-expand" id={detailId}>
        <p>{detail}</p>
      </div>
      <button
        className="usp-toggle"
        aria-expanded={open}
        aria-controls={detailId}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="usp-toggle-label">{toggleLabel}</span>
        <svg
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <polyline points="4 6 8 10 12 6" />
        </svg>
      </button>
    </article>
  );
}
